import { get } from '../../interview-sign-in/utils/request';
import { I18nText, QuestionItem, QuestionnaireState } from './model';
import { getCurrentLocale } from '../i18n/index';

export enum ErrorCode {
    ParseError = -2101007
}
export enum CompanyType {
    Bytedance = 1,
    Other = 0
}

export interface GetQuestionnaireTplPayload {
    questionnaire_token: string;
}
export interface Response {
    title_info: I18nText;
    company_name: I18nText;
    tenant_id: string;
    biz_modify_time: number;
    biz_create_time: number;
    questionnaire_state: QuestionnaireState;
    questionnaire_template_info: {
        title_info?: I18nText;
        question_list: QuestionItem[];
    };
    questionnaire_tenant: CompanyType;
}

export const getQuestionnaireTplRequest = (
    payload: GetQuestionnaireTplPayload
): Promise<Response> => {
    return get<Response>(`/atsx/public_api/questionnaire/get_questionnaire/`, payload, {
        notifyHttpError: true,
        headers: { 'accept-language': getCurrentLocale() }
    }).then(({ success, data, code, message }) => {
        if (!success || !data) {
            return Promise.reject({ code, message });
        }
        return data;
    });
};
